import { render, staticRenderFns } from "./SalesVolumeRank.vue?vue&type=template&id=4755fb9e&scoped=true"
import script from "./SalesVolumeRank.vue?vue&type=script&lang=js"
export * from "./SalesVolumeRank.vue?vue&type=script&lang=js"
import style0 from "./SalesVolumeRank.vue?vue&type=style&index=0&id=4755fb9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4755fb9e",
  null
  
)

export default component.exports